<template>
  <van-popup v-model="show" :close-on-click-overlay="close" overlay-class="a">
    <slot></slot>
  </van-popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  components: {
    [Popup.name]: Popup
  },
  props: {
    popShow: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    popShow (v) {
      console.log(v)
      this.show = v
    }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = this.popShow
  }
}
</script>
<style lang="less" scoped>
</style>
